(function () {
  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function formatMoneyFromCents(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return "";
    const euros = n / 100;
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR"
    }).format(euros);
  }

  function atobSafe(b64) {
    const pad = b64.length % 4;
    if (pad) b64 += "=".repeat(4 - pad);
    return atob(b64);
  }

  function decodeDataFromBtn(btn) {
    const b64 = btn.getAttribute("data-wcsm-b64");
    if (b64) return JSON.parse(atobSafe(b64));

    const raw = btn.getAttribute("data-wcsm-json");
    if (!raw) return null;

    const unescaped = raw
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, "&");

    return JSON.parse(unescaped);
  }

  function openModal(data) {
    const modal = qs(".wcsm-modal");
    const left = qs("#wcsm_modal_left");
    const list = qs("#wcsm_modal_products");

    if (!modal || !left || !list) return;

    left.innerHTML = "";

    if ((data.type || "").toLowerCase() === "video") {
      const v = document.createElement("video");
      v.src = data.media;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.autoplay = true;
      v.controls = false;

      left.appendChild(v);

      v.addEventListener("loadedmetadata", () => {
        v.play().catch(() => {});
      });
    } else {
      const img = document.createElement("img");
      img.src = data.media;
      img.alt = data.title || "";
      left.appendChild(img);
    }

    list.innerHTML = "";
    (data.products || []).forEach(p => {
      const card = document.createElement("div");
      card.className = "wcsm-product-card";
      card.innerHTML = `
        <div>
          <img src="${p.image}" alt="">
          <div class="price">${formatMoneyFromCents(p.price_cents)}</div>
          <p class="name">${p.name}</p>
          <a class="btn" href="${p.url}">SHOP</a>
        </div>
      `;
      list.appendChild(card);
    });

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    const modal = qs(".wcsm-modal");
    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";

    const left = qs("#wcsm_modal_left");
    if (left) left.innerHTML = "";
  }

  function initGridSlider() {
    const wrap = qs(".wcsm-slider-wrap");
    const grid = qs(".wcsm-grid", wrap || document);
    const prev = qs(".wcsm-slider-btn--prev", wrap || document);
    const next = qs(".wcsm-slider-btn--next", wrap || document);

    if (!wrap || !grid || !prev || !next) return;

    const items = qsa(".wcsm-item", grid);

    if (items.length <= 4) {
      wrap.classList.remove("has-slider");
      grid.classList.remove("is-slider");
      prev.classList.add("is-hidden");
      next.classList.add("is-hidden");
      return;
    }

    wrap.classList.add("has-slider");
    grid.classList.add("is-slider");

    function getStep() {
      const firstItem = items[0];
      if (!firstItem) return 300;

      const itemWidth = firstItem.offsetWidth;
      const styles = window.getComputedStyle(grid);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      return itemWidth + gap;
    }

    function updateArrows() {
      const maxScrollLeft = grid.scrollWidth - grid.clientWidth;
      prev.classList.toggle("is-hidden", grid.scrollLeft <= 5);
      next.classList.toggle("is-hidden", grid.scrollLeft >= maxScrollLeft - 5);
    }

    prev.addEventListener("click", () => {
      grid.scrollBy({ left: -getStep() * 2, behavior: "smooth" });
    });

    next.addEventListener("click", () => {
      grid.scrollBy({ left: getStep() * 2, behavior: "smooth" });
    });

    grid.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    updateArrows();
  }

  document.addEventListener("click", (e) => {
    if (e.target.matches("[data-wcsm-close]") || e.target.closest("[data-wcsm-close]")) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".wcsm-item");
    if (!btn) return;
    try {
      const data = decodeDataFromBtn(btn);
      if (!data) return;
      openModal(data);
    } catch (err) {
      console.warn("WCSM Shopify: no se pudo abrir modal", err);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });

  window.addEventListener("load", () => {
    qsa("video.wcsm-video").forEach(v => v.play().catch(() => {}));
    initGridSlider();
  });
})();